/* eslint-disable import/no-extraneous-dependencies */
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import Fragment from 'vue-fragment';
import VueMaskedInput from 'vue-masked-input';
import * as Sentry from '@sentry/vue';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-vue';
import VueSweetalert2 from 'vue-sweetalert2';
import VueHtmlToPaper from 'vue-html-to-paper';
import VueApexCharts from 'vue-apexcharts';
import GmapVue from 'gmap-vue';
import JsonExcel from 'vue-json-excel';
import store from '@/store';
import router from '@/router';
import App from '@/App.vue';
import appEnvConfig, { bvOptions, htmlToPaperOptions, sentryConfig } from '@/config';
import { observeAndAssignIds } from '@/shared/helpers/observe-and-assign-ids';
import vuetify from '@/plugins/vuetify';
import { GlobalComponentPlugin } from '@/plugins/global-component-plugin';
import { DynamicPluginAdapter } from '@/plugins/dynamic-plugin';
import { RsUtilitiesPlugin } from '@/plugins/utilities-plugin';
import { addScriptTagToHead } from './shared/helpers/add-script-tag-to-head';
import i18n from './i18n';

// Initialize Axios interceptors early to prevent circular dependency errors
import '@/shared/axios/index';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'overlayscrollbars/css/OverlayScrollbars.css';
import '@/styles/global.scss';

observeAndAssignIds();
addScriptTagToHead(appEnvConfig.fpnLatestScriptUrl);
addScriptTagToHead(appEnvConfig.fpnV2ScriptUrl);
addScriptTagToHead(appEnvConfig.fpnV25ScriptUrl);

Vue.config.productionTip = false;

Vue.config.ignoredElements = [
  'floorplan-navigator',
];

// Plugins
Vue.use(BootstrapVue, bvOptions);
Vue.use(VueApexCharts);
Vue.use(VueSweetalert2);
Vue.use(VueHtmlToPaper, htmlToPaperOptions);
Vue.use(GmapVue, {
  load: {
    key: window?.APP_CONFIG?.VUE_APP_GMAPS_API_KEY,
    libraries: 'places',
    // Render Canadian place names (e.g. "Lake Ontario") regardless of the viewer's locale
    region: 'CA',
  },
});
Vue.use(RsUtilitiesPlugin);
Vue.use(DynamicPluginAdapter);
Vue.use(GlobalComponentPlugin);

// Components
Vue.component('DownloadExcel', JsonExcel);
Vue.component('OverlayScrollbars', OverlayScrollbarsComponent);
Vue.component('Fragment', Fragment.Fragment);
Vue.component(VueMaskedInput);

if (
  ['staging', 'production'].includes(window?.APP_CONFIG?.VUE_APP_ENV)
  && window?.location.hostname !== 'localhost'
) {
  Sentry.init({
    app: Vue,
    ...sentryConfig,
  });
}

const vm = new Vue({ router, store, vuetify, i18n, render: (h) => h(App) }).$mount('#app');

export default () => vm;
